import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { PropertyService } from '../services/property.service';
import { map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivePropertyGuard implements CanActivate {
  private propertyService = inject(PropertyService);
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree > | Promise<boolean> | boolean | UrlTree {
    return this.propertyService.activeProperty.pipe(take(1), map( activeProperty => {

      if(activeProperty != null)
      {
        return true;
      }
      return this.router.createUrlTree(['/map'])
    }));
  }
}
